var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTodayPoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#006EFF",
  d: "M9.732 13c-.77 1.333-2.694 1.333-3.464 0L2.804 7c-.77-1.333.192-3 1.732-3h6.928c1.54 0 2.502 1.667 1.732 3z"
})));
export default SvgIconTodayPoint;